import React from 'react';
import { View, Text, ScrollView } from 'react-native';
import { oStyles } from '../olonkho-styles';

export default function AboutOlonkho({ navigation }) {
    return (
        <ScrollView style={ oStyles.about_container }>
            <Text style={ oStyles.about_title }>Что такое олонхо?</Text>
            <Text style={ { textAlign: 'right', fontSize: 10, fontFamily: 'times-italic', marginBottom: 10 } }>Олонхо – уникальное явление в мировой эпической культуре (В.Н. Иванов)</Text>
            <View style={ oStyles.about_content }>
                <Text>
                    <Text>          </Text>
                    <Text style={ { 
                        fontFamily: 'times-bold'
                     } }>Олонхо́</Text>
                    <Text style={ { 
                        fontFamily: 'times',
                        textAlign: 'justify'
                    } }> – героический эпос якутов (самоназвание – саха), тюркоязычного народа, заселившего примерно с VIII в. бассейн р. Лены. Представляет собой уникальный феномен генетической памяти, сконцентрировавшей в себе мировидение, философию, религиозные представления, обряды и обычаи предков саха, их песенной и устной сказительской традиции, и тем самым помогает сохранить на протяжении столетий культурную идентичность якутского народа.</Text>
                </Text>
                <Text>
                    <Text>          </Text>
                    <Text style={ { 
                        fontFamily: 'times',
                        textAlign: 'justify'
                    } }>Олонхо – самый крупный эпический жанр якутского фольклора. В нем воспеваются боевые подвиги богатырей племени айыы аймага, которые совершаются ими ради защиты родной земли, своих соплеменников, ради спокойной мирной жизни на земле, счастливого будущего потомков. Обычно эти подвиги совершаются в борьбе с богатырями племени злых чудовищ – абаасы аймаҕа.</Text>
                </Text>
                <Text>
                    <Text>          </Text>
                    <Text style={ { 
                        fontFamily: 'times',
                        textAlign: 'justify'
                    } }>Словом «олонхо» обозначают и отдельные сказания, относящиеся к данному жанру (например, «Нюргун Боотур Стремительный», «Эр Соготох», «Ого Тулаайах», «Ала Булкун» и др.) и в совокупности составляющие все богатство эпического наследия. Средний объем олонхо составляет 10-25 тысяч стихотворных строк. Самый объемный записанный текст олонхо – «Алаатыыр Ала Туйгун» достигает 50 тысяч стихотворных строк.</Text>
                </Text>
                <Text>
                    <Text>          </Text>
                    <Text style={ { 
                        fontFamily: 'times',
                        textAlign: 'justify'
                    } }>Олонхо передавалось из поколения в поколение устным способом. В прошлом бытовало во множестве вариантов, существовали локальные устные сказительские школы, например, таттинская, амгинская, усть-алданская, вилюйская, верхоянская и др. В современной науке выделяют три эпических традиций олонхо – центральную, вилюйскую и северную.</Text>
                </Text>
                <Text>
                    <Text>          </Text>
                    <Text style={ { 
                        fontFamily: 'times',
                        textAlign: 'justify'
                    } }>Олонхо исполняется без музыкального сопровождения. Форма исполнения – речитативная декламация с песнями: основное содержание сказывается нараспев, а речь каждого из персонажей поется в разной тональности.</Text>
                </Text>
                <Text>
                    <Text>          </Text>
                    <Text style={ { 
                        fontFamily: 'times',
                        textAlign: 'justify'
                    } }>Сказителей олонхо называют олонхосутами, они обладают природным даром импровизации, наделены исключительной памятью, богатым воображением и удивительной способностью своеобразного видения картины мира. Именитые олонхосуты имели в своем репертуаре большое количество олонхо, они могли сказывать одно олонхо в течение нескольких дней. Олонхосут – непревзойденный знаток родного языка, именно его образный, красочный язык превращает олонхо в искусство. Язык и стих олонхо представляет высшую форму обработанной, отшлифованной, художественно-организованной устной поэтической речи.</Text>
                </Text>
                <Text>
                    <Text>          </Text>
                    <Text style={ { 
                        fontFamily: 'times',
                        textAlign: 'justify'
                    } }>По письменным и архивным источникам сегодня выявлено свыше 1000 олонхосутов (XII–XXI вв.) прошлого и настоящего. Сбор памятников эпического наследия начался с середины 19 в. К настоящему времени всего собрано 126 версий в рукописном варианте, более 300 кассет магнитофонных и видеозаписей олонхо. Издано около 80 публикаций в книжном варианте.</Text>
                </Text>
                <Text>
                    <Text>          </Text>
                    <Text style={ { 
                        fontFamily: 'times',
                        textAlign: 'justify'
                    } }>25 ноября 2005 г. на Третьем Провозглашении ЮНЕСКО якутский героический эпос олонхо был признан шедевром устного и нематериального культурного наследия человечества. Провозглашение олонхо шедевром было воспринято общественностью республики как событие большого исторического и культурного значения, как интеллектуальный и творческий прорыв в мировое культурное пространство. И с 2005 года 25 ноября официально объявлено Днем Олонхо.</Text>
                </Text>
            </View>
        </ScrollView>
      );
}